import { SectionHeading } from "./styled/fragments";

const MetricsPanel: React.SFC = () => (
	<div>
		<SectionHeading title="Fancy timeseries plots" />
		yar
	</div>
)

export default MetricsPanel;



// WEBPACK FOOTER //
// ./src/core/components/editor/MetricsPanel.tsx